"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevelName = exports.getKoName = void 0;
var lodash_1 = __importDefault(require("lodash"));
var Config_1 = require("../utils/Config");
var Staff_1 = require("./Staff");
var CONTROL_KO_ATTRIBUTES = {
    id: '통제번호',
    goal: '통제목적',
    goal_Trust: '재무보고의 신뢰성',
    goal_Override: '부정방지',
    goal_Operation: '운영의 효율/효과',
    goal_Law: '법규 및 정책준수',
    goal_Asset: '자산의 보호',
    name: '통제활동 이름',
    narrative: '통제활동 설명',
    keyControl: 'Key Control',
    assertion: '경영진의 주장',
    assertion_EO: '실재성',
    assertion_C: '완전성',
    assertion_RO: '권리와 의무',
    assertion_PD: '표시와 공시',
    assertion_Occur: '발생사실',
    assertion_Assessment: '평가',
    assertion_Measurement: '측정',
    assertion_Cutoff: '기간귀속',
    accountName: '계정과목명',
    accountCode: '계정코드',
    riskNumber: '위험 코드',
    riskName: '위험명',
    controlRiskLevel: '통제 위험',
    residualRiskLevel: '통제의 잔여위험',
    policy: '관련규정집',
    teamLeader: '일반적인 경우 통제 책임자 정의',
    teamMember: '일반적인 경우 통제 담당자 정의',
    reportFootnotes: '관련주석',
    reviewControl: 'Review Control',
    period: '통제주기',
    preventDetective: '예방/적발 통제',
    autoManual: '수기/자동 통제',
    ITDependency: 'IT dependency',
    ITDependencySystem: 'Related System',
    autoProperty: 'Auto Control 속성',
    autoProperty_interface: 'Interface',
    autoProperty_calculation: 'Calculation',
    autoProperty_autocontrol: 'Auto Control',
    autoProperty_restrictedaccess: 'Restricted Access',
    autoProperty_sgi: 'SGI',
    MRC_YN: 'MRC 해당 여부',
    MRC_Number: 'MRC 번호',
    MRC_IPE_Number: 'MRC 관련 IPE 번호',
    MRC_IPE_Name: 'MRC 이름',
    IPE_YN: 'IPE 통제 해당 여부',
    IPE_Number: 'IPE 번호',
    IPE_Name: 'IPE 이름',
    EUC: 'EUC',
    department: '담당부서',
    incharge: '현재 RCM상 테스트 수행자',
    controlIncharge: '현재 테스트 수행자',
    controlOwner: '현재 통제 담당자',
    TOC_TestMethod: '운영평가 속성',
    TOC_TestMethod_InquiryInspection: '질문',
    TOC_TestMethod_Observation: '관찰',
    TOC_TestMethod_Reperformance: '재수행',
    TOC_Population: '모집단 정의',
    TOC_Period: '모집단 대상기간',
    TOC_Completeness: '모집단 완전성 검토',
    TOC_PopulationCount: '모집단 샘플수',
    TOC_SamplingCount: '샘플링 개수',
    TOC_TestProperties: '평가대상 항목',
    TOC_Exception: '예외사항',
    TOC_Evidence: '테스트 증빙',
    TOC_EvidenceSize: '증거자료크기',
    TOC_Procedure: '테스트 절차',
    TOC_Owner: '테스트 수행자',
    TOC_Department: '테스트 검토자',
    owner: '현재 RCM상 통제 담당자',
    departmentInRCM: '통제담당부서',
    inchargeInRCM: 'RCM 상 테스트 수행자',
    ownerInRCM: 'RCM 상 통제 담당자',
    ownerInTable: '통제 담당자',
    performerInTable: '테스트 수행자',
    // DAYOU
    department_description: '통제와 관련된 부서',
    nonKeyRational: 'Non-Key Rational',
    controlTypes: '통제종류',
    Control_Approval: '승인',
    Control_Verification: '검증',
    Control_PC: '물리적통제',
    Control_SIMC: '기준정보관리통제',
    Control_Reconciliation: '대사',
    autoControl: '자동통제',
    Control_RR: '업무분장',
    Control_RA: '접근제한',
    Control_IOA: '입력/출력 자동처리',
    Control_AC: '자동계산',
    Control_Interface: 'Interface',
    TOC_TestMethod_Examination: '문서검사',
    EUC_Identify: 'EUC 식별',
    // TPC
    euc_code: '관련 EUC 코드',
    euc_name: '관련 EUC 이름',
    team_name: '통제 관련 팀',
    control_category: '통제범주',
    // Helixmith
    IPE_Testing: 'IPE Testing',
    EUC_Testing: 'EUC Testing'
};
var DAYOU_CONTROL_KO_ATTRIBUTES = {
    assertion_Assessment: '정확성',
    assertion_Measurement: '평가',
    IPE_Name: 'IPE 식별'
};
var TPC_CONTROL_KO_ATTRIBUTES = {
    assertion_Cutoff: '기간귀속',
    assertion_Accuracy: '정확성',
    auto_application: 'Auto application',
    auto_application_interface: 'Interface',
    auto_application_calculation: 'Calculation',
    auto_application_autocontrol: 'Auto Control',
    auto_application_restricted: 'Restricted Access/SoD',
    auto_application_SGI: 'SGI',
    ITD_code: 'ITD 코드',
    ITD_name: 'ITD 명칭',
    fraud_yn: 'Fraud 관련 여부',
    Non_rational: 'Non-Key Rational',
    department_description: '통제 관련 부서',
    TOC_TestMethod_Examination: '문서검사'
};
var OE_KO_ATTRIBUTES = {
    number: '통제번호',
    period: '대상기간',
    executor: '테스트 수행자',
    performer: '테스트 수행자',
    createDate: '작성일자',
    updateTime: '수정일자',
    populationCount: '모집단 항목수',
    validCount: '유효 항목수',
    invalidCount: '비유효 항목수',
    testResult: '운영 테스트결과',
    populationDescription: '모집단 파일 및 설명',
    populationCompleteness: '모집단의 완전성 확인',
    samplingMethod: '샘플링 방법',
    samplingCount: '샘플링 항목수',
    populationTableColumnCount: '항목당 속성수',
    samplingAttributeCount: '테스트 속성수',
    controlException: '식별된 예외사항 기재',
    // Evaluation state
    Request: '수행요청',
    Unperformed: '미수행',
    Performing: '수행중',
    Performed: '수행완료',
    Rejected: '재작성필요',
    Approved: '승인완료',
    Exported: '엑셀 다운로드'
};
var DE_KO_ATTRIBUTES = {
    OwnerAssessment: '통제담당자 평가',
    TOC_TestControlElement: '통제요소',
    TOC_ProcedureContent: '수행한 절차의 내용'
};
function getControlKoName(key) {
    var name;
    var projectId = (0, Config_1.getProjectId)();
    if (projectId === 'dayouplus') {
        name = lodash_1.default.get(DAYOU_CONTROL_KO_ATTRIBUTES, key);
    }
    else if (projectId === 'tpc') {
        name = lodash_1.default.get(TPC_CONTROL_KO_ATTRIBUTES, key);
    }
    if (name) {
        return name;
    }
    name = lodash_1.default.get(CONTROL_KO_ATTRIBUTES, key);
    if (name) {
        return name;
    }
    name = lodash_1.default.get(OE_KO_ATTRIBUTES, key);
    if (name) {
        return name;
    }
    name = lodash_1.default.get(DE_KO_ATTRIBUTES, key);
    return name || '';
}
function getCommonKoName(key) {
    var COMMON_KO_ATTRIBUTES = {
        cycleName: '대분류',
        categoryName: '중분류',
        subCategoryName: '소분류',
        cycleNumber: '대분류 ID',
        categoryNumber: '중분류 번호',
        subCategoryNumber: '소분류 번호',
        processCode: '프로세스',
        fileName: '파일명',
        type: '종류',
        updater: '작성자',
        updateTime: '작성일자',
        cycle: '분류',
        process: '프로세스',
        risk: '리스크',
        control: '컨트롤'
    };
    return lodash_1.default.get(COMMON_KO_ATTRIBUTES, key);
}
function getProcessKoName(key) {
    var PROCESS_KO_ATTRIBUTES = {
        id: '프로세스 코드',
        name: '프로세스 이름',
        narrative: '설명'
    };
    return lodash_1.default.get(PROCESS_KO_ATTRIBUTES, key);
}
function getRiskKoName(key) {
    var RISK_KO_ATTRIBUTES = {
        id: '위험 코드',
        name: '위험명',
        RoMM: '재무제표 왜곡표시 위험',
        inherentRiskLevel: '고유위험'
    };
    return lodash_1.default.get(RISK_KO_ATTRIBUTES, key);
}
function getKoName(superKey, key, projectId) {
    var name;
    if (superKey === 'process') {
        name = getProcessKoName(key);
    }
    else if (superKey === 'risk') {
        name = getRiskKoName(key);
    }
    else if (superKey === 'control') {
        name = getControlKoName(key);
    }
    if (!(0, Config_1.hasThreeCategories)() && key === 'categoryName') {
        return '분류';
    }
    return name || getCommonKoName(key);
}
exports.getKoName = getKoName;
function getLevelName(key) {
    if (key === Staff_1.Level.ADMIN) {
        return '관리자';
    }
    if (key === Staff_1.Level.NORMAL) {
        return getKoName('control', 'performer');
    }
    if (key === Staff_1.Level.UPLOADER) {
        return '통제 담당자';
    }
    if (key === Staff_1.Level.WATCHER) {
        return '감사인';
    }
    return key;
}
exports.getLevelName = getLevelName;
//# sourceMappingURL=Translation.js.map